import { CheckboxGroupWUT } from '@wix/form-fields/wut';

export default CheckboxGroupWUT;
